export default "__VITE_ASSET__9afb93b0__"